// ----------------------------------------------------------------------------
// Template: Product
// ----------------------------------------------------------------------------
// 
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import {load} from '@shopify/theme-sections';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/reviews/reviews';
import 'snippets/cart-confirmation/cart-confirmation';
import 'snippets/_containers/swatches/swatches';
import 'snippets/size-guide/size-guide';
import 'snippets/product-zoom/product-zoom';
import 'snippets/models-modal/models-modal';

import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/product/product';
import 'sections/product-recommendations/product-recommendations';

// Styles
import './_product.scss';


// -------------------------------------
// Hooks
// -------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
